"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIControlledPopover = _interopRequireDefault(require("../../tooltip/UIControlledPopover"));

var _CalendarPage = _interopRequireDefault(require("./CalendarPage"));

var _UIPopoverBody = _interopRequireDefault(require("../../tooltip/UIPopoverBody"));

var _CalendarFooterButtons = _interopRequireDefault(require("./CalendarFooterButtons"));

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _createLazyPropType = _interopRequireDefault(require("../../utils/propTypes/createLazyPropType"));

var CalendarPagePopover =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CalendarPagePopover, _Component);

  function CalendarPagePopover() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CalendarPagePopover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CalendarPagePopover)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderCalendar = function () {
      var _this$props = _this.props,
          calendarId = _this$props.calendarId,
          clearLabel = _this$props.clearLabel,
          max = _this$props.max,
          maxValidationMessage = _this$props.maxValidationMessage,
          min = _this$props.min,
          minValidationMessage = _this$props.minValidationMessage,
          onChange = _this$props.onChange,
          today = _this$props.today,
          todayLabel = _this$props.todayLabel,
          __id = _this$props.id,
          __open = _this$props.open,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["calendarId", "clearLabel", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel", "id", "open"]);
      return _react.default.createElement(_UIPopoverBody.default, null, _react.default.createElement(_CalendarPage.default, (0, _extends2.default)({}, rest, {
        id: calendarId,
        max: max,
        maxValidationMessage: maxValidationMessage,
        min: min,
        minValidationMessage: minValidationMessage,
        onChange: onChange,
        tabIndex: -1,
        today: today
      })), _react.default.createElement(_CalendarFooterButtons.default, {
        clearLabel: clearLabel,
        max: max,
        maxValidationMessage: maxValidationMessage,
        min: min,
        minValidationMessage: minValidationMessage,
        onChange: onChange,
        today: today,
        todayLabel: todayLabel
      }));
    };

    return _this;
  }

  (0, _createClass2.default)(CalendarPagePopover, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          id = _this$props2.id,
          onFocusLeave = _this$props2.onFocusLeave,
          onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open;
      return _react.default.createElement(_UIControlledPopover.default, {
        arrowSize: "none",
        autoPlacement: "vert",
        Content: this.renderCalendar,
        onOpenChange: onOpenChange,
        pinToConstraint: ['left', 'right'],
        placement: "bottom right",
        id: id,
        onFocusLeave: onFocusLeave,
        open: open
      }, children);
    }
  }]);
  return CalendarPagePopover;
}(_react.Component);

if (process.env.NODE_ENV !== 'production') {
  CalendarPagePopover.propTypes = {
    calendarId: _propTypes.default.string.isRequired,
    calendarPage: _propTypes.default.shape({
      year: _propTypes.default.number.isRequired,
      month: _propTypes.default.number.isRequired
    }),
    children: _propTypes.default.node.isRequired,
    clearLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
    max: _SimpleDateTypes.SimpleDateType,
    maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    min: _SimpleDateTypes.SimpleDateType,
    minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    onCalendarPageChange: _propTypes.default.func.isRequired,
    onChange: _CalendarPage.default.propTypes.onChange,
    onFocusLeave: _UIControlledPopover.default.propTypes.onFocusLeave,
    onOpenChange: _propTypes.default.func.isRequired,
    open: _propTypes.default.bool.isRequired,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    todayLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
    value: _CalendarPage.default.propTypes.value
  };
}

var _default = CalendarPagePopover;
exports.default = _default;
module.exports = exports.default;